// https://www.w3.org/TR/mediaqueries-4/#mq-min-max
var range = function range(feature, min, max) {
  var isRange = max && max !== true;
  var isMin = isRange || max === false;
  var isMax = max === true;
  var prefix = '';
  if (isMax) prefix = 'max-';
  if (isMin) prefix = 'min-';
  var expression = min ? "".concat(prefix + feature, ": ").concat(min) : feature;
  if (isRange) expression += ") and (max-".concat(feature, ": ").concat(max);
  return expression;
};

export { range };
//# sourceMappingURL=range.js.map
